'use client'

import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'

export function useVideoMetaFixed() {
	const pathname = usePathname()
	const [videoIdxValue, setVideoIdxValue] = useState<string | null>(null)
	/**
	 * @param videoIdxValue
	 * @summary 비디오 아티스트 고정
	 * @description
	 * 비디오 플레이어 videoreadytoplay 이벤트 캐치, isReady 일 경우
	 * ios, aos MediaSession metadata artist 고정, title 수정
	 * 비디오 모듈에서 정의 중이나, 프론트에서 가공 요청
	 */
	useEffect(() => {
		if (!videoIdxValue) return
		const title = document.querySelector('title')
			? document?.querySelector('title')?.innerText
			: 'JTBC NEWS'
		try {
			if (navigator?.mediaSession?.metadata) {
				// navigator.mediaSession.metadata.title = String(title) // TODO: API 수정 테스트 중
				navigator.mediaSession.metadata.artist = 'JTBC NEWS'
			}
		} catch (error) {
			console.error('mediaSession', error)
		}
	}, [pathname, videoIdxValue])

	return setVideoIdxValue
}
